import { Routes } from '@angular/router';
import { StepIds } from '../models/property-step/property-step-model';
import { PropertyPhotosPageComponent } from '../pages/property-default-pages/property-photos-page/property-photos-page.component';
import { PropertyAgentPromotePageComponent } from '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.component';
import { PropertyInformationComponent } from '../pages/category-page-overrides/rural/property-information-page.component';
import { PropertyDescriptionComponent } from '../pages/category-page-overrides/rural/property-description-page.component';
import { PropertySummaryPageComponent } from '../pages/category-page-overrides/rural/property-summary-page.component';

export const ruralRoutes: Routes = [
    {
        path: '',
        redirectTo: StepIds.propertyInformation,
        pathMatch: 'full'
    },
    {
        path: StepIds.propertyInformation,
        component: PropertyInformationComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyInformation
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/rural/property-information-page.module'
            ).then((mod) => mod.PropertyInformationPageModule)
    },
    {
        path: StepIds.propertyDescription,
        component: PropertyDescriptionComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyDescription
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/rural/property-description-page.module'
            ).then(
                (mod) =>
                    mod.PropertyDescriptionPageModule
            )
    },
    {
        path: StepIds.propertyPhotos,
        component: PropertyPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPhotos
            }
        }
    },
    {
        path: StepIds.propertyPromote,
        component: PropertyAgentPromotePageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPromote
            }
        },
        loadChildren: () =>
            import(
                '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.module'
            ).then((mod) => mod.PropertyAgentPromotePageModule)
    },
    {
        path: StepIds.propertySummary,
        component: PropertySummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertySummary
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/rural/property-summary-page.module'
            ).then(
                (mod) => mod.PropertySummaryPageModule
            )
    }
];